import React, { useMemo, useContext } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPageHeader } from 'e1p-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { AmfamOktaTokenContext } from 'e1p-capability-gateway-react';
import { useTranslator } from '@jutro/locale';
import { commonMessages } from 'e1p-platform-translations';
import styles from './ThankYouPage.module.scss';
import metadata from './ThankYouPage.metadata.json5';


const LOB = 'personalAuto_EA';

function ThankYouPage(props) {
    const { wizardData: rewriteDataVM } = props;

    const viewModelService = useContext(ViewModelServiceContext);

    const policyNumber = useMemo(() => _.get(rewriteDataVM, 'bindData.policyNumber.value'), [rewriteDataVM]);

    const onPrintHandler = () => {
        window.print();
    };

    const translator = useTranslator();
    const { opCo } = useContext(AmfamOktaTokenContext);

    const overrideProps = {
        '@field': {
            labelPosition: 'top',
            autoComplete: false
        },
        exitToDashBoardButtonId: {
            to: `/policies/${policyNumber}/summary`,
        },
        messagesContainer: {
            submissionVM: rewriteDataVM,
            viewModelService,
            LOB
        },
        policyDocumentContainer: {
            submissionVM: rewriteDataVM
        },
        addANewLineComponent: {
            submissionVM: rewriteDataVM
        },
        requiredDocumentContainer: {
            submissionVM: rewriteDataVM,
            viewModelService
        },
        wizardHeaderContainer: {
            wizardSubmission: rewriteDataVM,
            isSideHeader: false,
            shouldLink: false,
            isPolicyView: false
        },
        thankyouMessageLabelId: {
            content: opCo === 'MSA' ? translator(commonMessages.thankYouMessage, { partner: translator(commonMessages.msa) })
                : translator(commonMessages.thankYouMessage, { partner: translator(commonMessages.connect) })
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            wizardpageheader: WizardPageHeader
        },
        resolveCallbackMap: {
            onPrintHandler
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={rewriteDataVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

ThankYouPage.propTypes = wizardProps;
export default ThankYouPage; 
